<template>
  <div class="svgCon">
    <svg
      id="svgc"
      style="width:100%;height:100%"
    ></svg>
    <div class="planRoadCon">
      <div
        class="lashBtn"
        ref='lashBtnId'
        @click="shfBtn"
      >—</div>
      <div
        style="display: flex;"
        v-show='shfFlag'
      >
        <div class="icons">
          <div class="greenDot">起</div>
          <div
            class="dashedLine"
            ref='ruLine'
          ></div>
          <div class="grayDot">上</div>
          <div
            class="dashedLine"
            style="height:.27rem;"
          ></div>
          <div class="grayDot">下</div>
          <div
            class="dashedLine"
            style="height:.32rem;"
          ></div>
          <div class="redDot">终</div>
        </div>
        <div class="chooseCon">
          <div class="placeStation">
            <div class="places">{{ruObj.val}}</div>
            <div
              class="addressL gray"
              ref="ruAdd"
            >{{ruObj.address}}</div>
          </div>
          <div class="placeStation">
            <div class="places"><span class="gray">上高速口</span>&nbsp;&nbsp;&nbsp;<span>{{ruStationObj.name}}</span></div>
          </div>
          <div class="placeStation">
            <div class="places"><span class="gray">下高速口</span>&nbsp;&nbsp;&nbsp;<span>{{chuStationObj.name}}</span></div>
          </div>
          <div class="placeStation">
            <div class="places">{{chuObj.val}}</div>
            <div class="addressL gray">{{chuObj.address}}</div>
          </div>
        </div>
      </div>
      <div class="avenueDiv">
        <span style="font-size:.16rem;color:rgba(51,51,51,1);line-height:.22rem;font-weight: bolder;margin-right:.1rem">{{formObj.totalMiles}}公里|途径</span>{{formObj.roadline}}
      </div>
      <div class="roadAbout">
        <div class="titles">
          <div style="font-size:.16rem;color:rgba(51,51,51,1);line-height:.22rem;font-weight: bolder;">交通概况</div>
          <div
            class="toDetial"
            @click='checkList'
          >查看详情></div>
        </div>
        <div class="aboutCon">
          <ul>
            <li>
              交通拥堵 <span style="color:#199EF4;font-size:.12rem;font-weight: bolder;"> {{formObj.slow}}</span>
            </li>
            <li>
              交通事故 <span style="color:#199EF4;font-size:.12rem;font-weight: bolder;"> {{formObj.event}}</span>
            </li>
            <li>
              管制信息 <span style="color:#199EF4;font-size:.12rem;font-weight: bolder;"> {{formObj.control}}</span>
            </li>
            <li>
              道路施工 <span style="color:#199EF4;font-size:.12rem;font-weight: bolder;"> {{formObj.construction}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 回简图 -->
    <div
      class="gobackJian"
      @click="gobackJian"
    >回简图 ›</div>
    <!-- 切换列表 -->
    <div
      class="checkList"
      @click="checkList"
    >切换列表 ›</div>
    <!-- 事件弹出层 -->
    <cube-popup
      type="my-popup"
      position="bottom"
      :mask-closable="true"
      ref="sjPopup"
      @mask-click='sjHide'
    >
      <div
        class="cube-extend-popup-content"
        @click="sjHide"
      >
        <slot>
          <div class="stationCon">
            <div class="titleCon">
              <div style="width:.38rem;height:.38rem;">
                <img
                  src="../../assets/img/img01_active.png"
                  alt=""
                  v-show="sjDetialFrom.eventtype == 1006301"
                >
                <img
                  src="../../assets/img/img02_active.png"
                  alt=""
                  v-show="sjDetialFrom.eventtype == 1006302"
                >
                <img
                  src="../../assets/img/img03_active.png"
                  alt=""
                  v-show="sjDetialFrom.eventtype == 1006303"
                >
                <img
                  src="../../assets/img/img04_active.png"
                  alt=""
                  v-show="sjDetialFrom.eventtype == 1006002"
                >
                <img
                  src="../../assets/img/img05_active.png"
                  alt=""
                  v-show="sjDetialFrom.eventtype == 1006003"
                >
              </div>
              <div class="sjName">
                <div>
                  <span
                    class="sjNameText"
                    v-show="sjDetialFrom.eventtype == 1006301"
                  >事故</span>
                  <span
                    class="sjNameText"
                    v-show="sjDetialFrom.eventtype == 1006302"
                  >阻塞</span>
                  <span
                    class="sjNameText"
                    v-show="sjDetialFrom.eventtype == 1006303"
                  >管制</span>
                  <span
                    class="sjNameText"
                    v-show="sjDetialFrom.eventtype == 1006002"
                  >正在施工</span>
                  <span
                    class="sjNameText"
                    v-show="sjDetialFrom.eventtype == 1006003"
                  >施工计划</span>

                  <span
                    v-show="sjDetialFrom.status == 1008001"
                    class="tipsty"
                    style="background:#128746;color:#fff;"
                  >畅通</span>
                  <span
                    v-show="sjDetialFrom.status == 1008002"
                    class="tipsty"
                    style="background:#ffbb12;color:#fff;"
                  >缓行</span>
                  <span
                    v-show="sjDetialFrom.status == 1008003"
                    class="tipsty"
                    style="background:#f76260;color:#fff;"
                  >滞留</span>
                  <span
                    v-show="sjDetialFrom.status == 1008004"
                    class="tipsty"
                    style="background:#73859f;color:#fff;"
                  >阻断</span>
                </div>
                <div class="address">
                  {{sjDetialFrom.shortname}}
                  {{sjDetialFrom.directionname}}
                </div>
              </div>
              <div
                class="closePop"
                @click="sjHide"
              >X</div>
            </div>
            <div class="mainCon">
              {{sjDetialFrom.reportout}}
            </div>
            <div class="mainPot">
              <ul>
                <li>
                  <div class="valCon">{{sjDetialFrom.startstake}}-{{sjDetialFrom.endstake}}</div>
                  <div class="keyCon">桩号区间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002||sjDetialFrom.eventtype == 1006003">
                  <div class="valCon">{{sjDetialFrom.occtime}}</div>
                  <div class="keyCon">开始时间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002&&sjDetialFrom.eventtype != 1006003">
                  <div class="valCon">{{sjDetialFrom.startstake}}-{{sjDetialFrom.endstake}}</div>
                  <div class="keyCon">站点区间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002||sjDetialFrom.eventtype == 1006003">
                  <div class="valCon">{{sjDetialFrom.startstake}}</div>
                  <div class="keyCon">持续时间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002&&sjDetialFrom.eventtype != 1006003">
                  <div class="valCon">{{sjDetialFrom.startstake}}</div>
                  <div class="keyCon">处理进度</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002||sjDetialFrom.eventtype == 1006003">
                  <div class="valCon">{{sjDetialFrom.eventcausename}}</div>
                  <div class="keyCon">施工方式</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002&&sjDetialFrom.eventtype != 1006003">
                  <div class="valCon">{{sjDetialFrom.distance}}</div>
                  <div class="keyCon">拥堵距离</div>
                </li>
              </ul>
            </div>
          </div>
        </slot>
      </div>
    </cube-popup>
  </div>
</template>

<script>
import svgPanZoom from "svg-pan-zoom";

import "../../assets/js/hammer.min.js";
import eventBus from "../../utils/eventBus.js";

export default {
  data() {
    return {
      paper: "",
      eventsHandler: "",
      tstype: true,
      dyctype: true,
      wlyctype: true, //网络延迟提示判断
      timer: null,
      ruObj: {},
      chuObj: {},
      ruStationObj: {},
      chuStationObj: {},
      // 图标大小
      iconHeight: 14,
      iconWidth: 14,
      // 图标偏移
      iconPx: 7,
      iconPy: 11,
      sjDetialFrom: {},
      formObj: {},
      shfFlag: false,
      planRoadHeight: 0,
    };
  },
  mounted() {
    this.initFun();
    this.ruObj = JSON.parse(sessionStorage.getItem("ruObj"));
    this.chuObj = JSON.parse(sessionStorage.getItem("chuObj"));
    this.ruStationObj = JSON.parse(sessionStorage.getItem("ruStationObj"));
    this.chuStationObj = JSON.parse(sessionStorage.getItem("chuStationObj"));
    let that = this;
    // if (window.history && window.history.pushState) {
    //   // 往历史记录里面添加一条新的当前页面的url
    //   history.pushState(null, null, document.URL);
    //   // 给 popstate 绑定一个方法 监听页面刷新
    //   window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    // }
  },
  beforeDestroy() {
    // eventBus.$off("formObj");
    eventBus.$emit("formObj", this.formObj);
  },
  destroyed() {
    // window.removeEventListener("popstate", this.backChange, false);
  },
  methods: {
    shfBtn() {
      let planRoadDom = document.querySelector(".planRoadCon");
      if (this.shfFlag) {
        this.shfFlag = false;
        // planRoadDom.style.height = "165px";
      } else {
        this.shfFlag = true;
        this.$nextTick(() => {
          this.planRoadHeight =
            document.querySelector(".planRoadCon").offsetHeight + 20;
          this.$refs.ruLine.style.height =
            this.$refs.ruAdd.offsetHeight + 23 + "px";
        });

        // planRoadDom.style.height = 'auto';
      }
    },
    backChange() {
      console.log('go to fastChoose')
      this.$router.push(
        `/fastChoose`
      );
    },
    initFun() {
      let that = this;
      Snap.load(
        require("../../assets/SVG/001-01.svg"),
        function (f) {
          // layer.closeAll('loading');
          var g = Snap("#svgc");
          var svg = f.select("svg");
          g.g().add(svg);
          that.paper = g;
          that.getData();
          // var allpoinameimg = paper.select("#收费站图标");
          var allpoiname = that.paper.select("#收费站文字");
          //paper.select("#图例").attr({'opacity': '0'});
          //手机缩放
          that.eventsHandler = {
            haltEventListeners: [
              "touchstart",
              "touchend",
              "touchmove",
              "touchleave",
              "touchcancel",
            ],
            init: function (options) {
              var instance = options.instance,
                initialScale = 1,
                pannedX = 0,
                pannedY = 0;
              // Init Hammer
              // Listen only for pointer and touch events
              this.hammer = Hammer(options.svgElement, {
                inputClass: Hammer.SUPPORT_POINTER_EVENTS
                  ? Hammer.PointerEventInput
                  : Hammer.TouchInput,
              });

              // Enable pinch
              this.hammer.get("pinch").set({ enable: true });

              // Handle double tap
              this.hammer.on("doubletap", function (ev) {
                instance.zoomIn();
              });

              // Handle pan
              this.hammer.on("panstart panmove", function (ev) {
                if (ev.type === "panstart") {
                  pannedX = 0;
                  pannedY = 0;
                }

                // Pan only the difference
                instance.panBy({
                  x: ev.deltaX - pannedX,
                  y: ev.deltaY - pannedY,
                });
                pannedX = ev.deltaX;
                pannedY = ev.deltaY;

                //实现函数防抖
                if (that.timer != null) {
                  clearTimeout(that.timer);
                }

                that.timer = setTimeout(function () {}, 500);
              });

              // Handle pinch
              this.hammer.on("pinchstart pinchmove", function (ev) {
                // On pinch start remember initial zoom
                if (ev.type === "pinchstart") {
                  initialScale = instance.getZoom();
                  instance.zoom(initialScale * ev.scale);
                }

                instance.zoom(initialScale * ev.scale);
              });

              // Prevent moving the page on some devices when panning over SVG
              options.svgElement.addEventListener("touchmove", function (e) {
                e.preventDefault();
              });
            },

            destroy: function () {
              this.hammer.destroy();
            },
          };
          panZoom = window.panZoom = svgPanZoom("#svgc", {
            viewportSelector: ".svg-pan-zoom_viewport",
            panEnabled: true,
            zoomEnabled: true,
            dblClickZoomEnabled: true,
            mouseWheelZoomEnabled: true,
            preventMouseEventsDefault: true,
            zoomScaleSensitivity: 0.3,
            minZoom: 0.5,
            maxZoom: 100,
            fit: true,
            center: true,
            refreshRate: "auto",
            customEventsHandler: that.eventsHandler,
            onZoom: function () {
              // layer.load(20);
              return; // resMapOld
              //放大后的数值
              var newzoom = panZoom.getZoom();
              var newpan = panZoom.getPan();
            },
          });

          panZoom.reset();
          panZoom.zoom(1.1);
          panZoom.panBy({ x: 0, y: -100 });
          that.refreshEvent(); //去除原先的事件等图层
          that.dyctype = false;
        }
      );
    },
    refreshEvent() {
      // layer.load(2);
      this.dyctype = true;
      this.tstype = true;
      this.wlyctype = true;
      this.removeEventBySvg();
    },
    removeEventBySvg() {
      if (!!this.paper.select("#event_g")) {
        this.paper.select("#event_g").remove();
      }
      if (!!this.paper.select("#event_sg")) {
        this.paper.select("#event_sg").remove();
      }
      if (!!this.paper.select("#event_gz")) {
        this.paper.select("#event_gz").remove();
      }

      //2018-9-13  chenping-change
      if (!!this.paper.select("#event_pv")) {
        this.paper.select("#event_pv").remove();
      }
      //end

      if (!!this.paper.select("#cctv_g")) {
        this.paper.select("#cctv_g").remove();
      }
    },
    getData() {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true,
        time: 100000,
      }).show();
      this.$Post(
        "highwayInfoSVGWeb/fetchPathByInOut",
        {
          instationcode: this.$route.query.instationcode,
          outstationcode: this.$route.query.outstationcode,
        },
        ({ data }) => {
          this.formObj = data;
          if (data.trafficsplitcode.length) {
            data.trafficsplitcode.forEach((item) => {
              this.lightRoad(item);
            });
          }
          this.churuStation(this.formObj.instationcode, "inUp");
          this.churuStation(this.formObj.outstationcode, "outDown");
          loadingToast.hide();
        },
        (err) => {
          loadingToast.hide();
          this.$alertShow(err.msg);
        },
        true
      );
    },
    churuStation(id, eventimg) {
      let pathLo = this.paper.select(`#${id}`);
      if (pathLo) {
        var x = pathLo.getBBox().cx;
        var y = pathLo.getBBox().cy;
        var imgObj = this.getEvenIcon(x, y, eventimg);
        if (!this.paper.select("#event_mixchuru")) {
          let tmp = Snap.parse(`<g id= 'event_mixchuru'></g>`);
          this.paper.select("#layer2").parent().add(tmp);
        }
        var img = this.paper.select("#event_mixchuru").g();
        img.add(imgObj);
      }
    },
    // 点亮道路
    lightRoad(obj) {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true,
        time: 100000,
      }).show();
      let pathLo = this.paper.select(`#f${obj.trafficsplitcode}`);
      if (pathLo) {
        let paths = pathLo.clone();
        paths.attr({
          "stroke-width": "3.8",
          stroke: "#197134",
          id: obj.trafficsplitcode,
        });
        let tmp = Snap.parse('<g id="temp_g3"></g>');
        this.paper.select("#layer3").add(tmp);
        // var img = this.paper.image(eventimg, x, y, 24, 28);
        this.paper.select("#temp_g3").add(paths);
      }
      if (obj.eventids) {
        let eventimg;
        if (obj.eventtype == "1006302") {
          eventimg = "zuse";
        } else if (obj.eventtype == "1006301") {
          eventimg = "shigu";
        } else if (obj.eventtype == "1006303") {
          eventimg = "guanzhi";
        } else if (obj.eventtype == "1006002") {
          eventimg = "shigong";
        } else if (obj.eventtype == "1006003") {
          eventimg = "shiji";
        } else {
          return;
        }
        this.shiguIcon(obj, eventimg, obj.eventtype);
      }
      loadingToast.hide();
    },
    // 事件图标
    shiguIcon(item, eventimg, strtype) {
      if (!item.trafficsplitcode) return;
      if (item.trafficsplitcode.indexOf("s") == -1) {
        let pathLo = this.paper.select(`#f${item.trafficsplitcode}`);
        if (pathLo) {
          let tuLength = pathLo.getTotalLength();
          let scale = tuLength / item.trueLength;
          if (item.flag == "1") {
            // 图标显示
            let iconObj = pathLo.getPointAtLength(
              item.getPointAtLength * scale
            );
            var imgObj = this.getEvenIcon(iconObj.x, iconObj.y, eventimg);
            if (!this.paper.select("#event_mix_" + strtype)) {
              let tmp = Snap.parse(`<g id= 'event_mix${strtype}'></g>`);
              this.paper.select("#layer2").parent().add(tmp);
            }
            var img = this.paper.select("#event_mix" + strtype).g();
            img.add(imgObj);
            img.attr({ x: iconObj.x });
            img.attr({ y: iconObj.y });
            img.attr({ cursor: "pointer" });
            img.attr({ class: strtype });
            img.click(() => {
              this.sgdjck(item, "sj", eventimg);
            });
          }
          // 路段变色
          let color = "";
          if (item.status == "1008002") {
            color = "#ffff00";
          } else if (item.status == "1008003") {
            color = "#ff0000";
          } else if (item.status == "1008004" || item.status == "1008005") {
            color = "#cccccc";
          }
          let arr = item.strokeStr.split(",");
          let scalearr = arr.map((itemPoit) => {
            return itemPoit * scale;
          });
          pathLo.clone().attr({
            stroke: color,
            "stroke-dasharray": scalearr,
          });
        }
      } else {
        let pathLo = this.paper.select(`#${item.trafficsplitcode}`);
        if (pathLo) {
          if (item.flag == "1") {
            var x = pathLo.getBBox().cx;
            var y = pathLo.getBBox().cy;
            var imgObj = this.getEvenIcon(x, y, eventimg);
            if (!this.paper.select("#event_mix_" + strtype)) {
              let tmp = Snap.parse(`<g id= 'event_mix${strtype}'></g>`);
              this.paper.select("#layer2").parent().add(tmp);
            }
            var img = this.paper.select("#event_mix" + strtype).g();
            img.add(imgObj);
            img.attr({ cursor: "pointer" });
            img.click(() => {
              this.sgdjck(item, "sj", eventimg);
            });
          }
        }
      }
    },
    // 产生图标
    getEvenIcon(x, y, src) {
      let obj = null;
      let pos_x = x - this.iconPx;
      let pos_y = y - this.iconPy;
      let str = ` <image x="${pos_x}" y="${pos_y}" height="${
        this.iconHeight
      }px" width="${
        this.iconWidth
      }px" xlink:href=${require(`../../assets/img/${src}.png`)}></image>`;
      obj = Snap.parse(str);
      return obj;
    },
    //点击查看详情
    sgdjck(data, type, eventimg) {
      let ph;
      if (type == "sj") {
        if (data.trafficsplitcode.indexOf("s") == -1) {
          ph = this.paper.select("#f" + data.trafficsplitcode);
        } else {
          ph = this.paper.select("#" + data.trafficsplitcode);
        }
      } else {
        ph = this.paper.select("#" + data.trafficsplitcode);
      }
      let tuLength = ph.getTotalLength();
      let scale = tuLength / data.trueLength;
      let iconObj = ph.getPointAtLength(data.getPointAtLength * scale);
      let x = iconObj.x - (this.iconWidth - 0.3);
      let y = iconObj.y - (this.iconHeight + 2);
      if (this.paper.select("#temp_g")) {
        this.paper.select("#temp_g").remove();
      }
      let tmp = Snap.parse('<g id="temp_g"></g>');
      this.paper.select("#layer2").parent().add(tmp);
      let img = this.paper.image(
        require(`../../assets/img/${eventimg}.png`),
        x,
        y,
        this.iconWidth * 2 + "px",
        this.iconHeight * 2 + "px"
      );
      let name = this.paper.text(x, y, data.name);
      this.paper.select("#temp_g").add(img);
      this.paper.select("#temp_g").add(name);
      this.showAlertDetails(data);
    },
    showAlertDetails(obj) {
      this.$refs.sjPopup.show();
      this.sjDetialFrom = obj;
    },
    sjHide() {
      this.paper.select("#temp_g").remove();
      this.$refs.sjPopup.hide();
    },
    gobackJian() {
      sessionStorage.clear();
      if (this.$route.query.comeFrom == 1) {
        if (this.$route.params.browser.versions.android) {
          window.liaoningactivity.bankSignResult("0", "5");
        } else {
          window.customServiceBack();
        }
      } else {
        this.$router.push("/");
      }
    },
    checkList() {
      this.$router.push(
        `/roadDetialList?instationcode=${this.$route.query.instationcode}&outstationcode=${this.$route.query.outstationcode}`
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.lashBtn {
  text-align: center;
  color: rgba(0, 0, 0, 0.07);
  height: .26rem;
  font-weight: bolder;
  font-size: .26rem;
  line-height: .26rem;
}
.svgCon {
  height: 100%;
}
.gray {
  color: #b9b8b8;
}
.gobackJian {
  position: fixed;
  top: .35rem;
  left: .1rem;
  padding: .07rem .12rem;
  background: #fff;
  border-radius: .16rem;
  box-shadow: 0px .02rem .06rem 0px #ccc;
  font-size: .13rem;
  color: #199ef4;
}
// .checkList {
//   position: fixed;
//   top: 20px;
//   right: 10px;
//   padding: 7px 12px;
//   background: #fff;
//   border-radius: 16px;
//   box-shadow: 0px 2px 6px 0px #ccc;
//   font-size: 13px;
//   color: #199ef4;
// }
.planRoadCon {
  position: fixed;
  bottom: 0;
  // height: 235px;
  width: 100%;
  box-shadow: 0px -.01rem .06rem 0px rgba(0, 0, 0, 0.07);
  border-radius: .12rem .12rem 0px 0px;
  background-color: #fff;
  // padding: 30px 0;
  .icons {
    width: 10%;
    margin-top: .09rem;
    padding-left: .22rem;
    font-size: .8rem;
    .greenDot,
    .redDot,
    .grayDot {
      width: .14rem;
      height: .14rem;
      border-radius: .07rem;
      text-align: center;
      line-height: .15rem;
      color: #fff;
    }
    .greenDot {
      background-color: #07cc94;
    }
    .redDot {
      background-color: #f93a3a;
    }
    .grayDot {
      background-color: #b9b8b8;
    }
    .dashedLine {
      border-right: .01rem dashed #b9b8b8;
      height: .64rem;
      width: .01rem;
      margin-left: .05rem;
    }
  }
  .chooseCon {
    font-size: .16rem;
    .placeStation {
      margin-bottom: .18rem;
      line-height: 1.5;
      .addressL {
        font-size: .12rem;
        // overflow: hidden;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        // -ms-text-overflow: ellipsis;
        // text-overflow: ellipsis;
      }
    }
  }
  .avenueDiv {
    font-size: .12rem;
    font-weight: 400;
    margin-top: .13rem;
    margin-left: .1rem;
  }
}
.stationCon {
  background: #fff;
  padding: .2rem .1rem;
  .titleCon {
    display: flex;
    .sjName {
      width: 85%;
      margin-left: .13rem;
      .sjNameText {
        font-size: .16rem;
        font-weight: 600;
      }
      .tipsty {
        padding: 0 .07rem;
        border-radius: .085rem;
        font-size: .12rem;
      }
      .address {
        margin-top: .07rem;
        font-size: .14rem;
        color: #6b6b6b;
      }
    }
    .closePop {
      color: #c8c8c8;
      float: right;
    }
  }
  .mainCon {
    font-size: .14rem;
    color: #6b6b6b;
    margin: .1rem 0;
  }
  .mainPot {
    ul {
      display: flex;
      justify-content: space-around;
      text-align: center;
      .valCon {
        font-weight: bold;
        font-size: .14rem;
        margin: .12rem 0;
      }
      .keyCon {
        font-size: .12rem;
        font-weight: 400;
      }
    }
  }
}
.roadAbout {
  padding: .1rem;
  margin-bottom: 0.1rem;
  .titles {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .toDetial {
      font-size: .12rem;
      color: #199ef4;
    }
  }
  .aboutCon {
    ul {
      display: flex;
      font-size: .12rem;
      justify-content: space-between;
      margin-top: .1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/fastChoose/planRoad.vue